import { generatePath, NavLink } from 'react-router-dom';
import { IconChangeLoClock, IconCloseCircle, PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';
import { CustomerStatus } from '../../../common/types';

import ROUTES from '../../../../routes';

import commonStyles from '../../../common/common.module.css';

const OverviewTopContent = ({
  setChangeLogPanelIsOpen,
  setReopenPopupVisible,
}: {
  setChangeLogPanelIsOpen: (data: boolean) => void;
  setReopenPopupVisible: (data: boolean) => void;
}) => {
  const { baseInformation } = useAppSelector(
    (state) => state.corporateCustomers.info.general,
  );
  const { activePermissions } = useAppSelector((state) => state.root);

  return (
    <>
      <div
        className={`${commonStyles.overviewTitleWrapper} ${
          !baseInformation?.name ? commonStyles.flexEnd : ''
        }`}
      >
        {baseInformation?.name && (
          <div className={commonStyles.overviewTitle}>
            {baseInformation.name}
          </div>
        )}

        <div className={commonStyles.overviewTopRight}>
          {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
            <button
              className={commonStyles.applicationLink}
              type="button"
              onClick={() => setChangeLogPanelIsOpen(true)}
            >
              <IconChangeLoClock />
              Change Log
            </button>
          )}
          {baseInformation?.applicationId && (
            <NavLink
              to={generatePath(
                ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_INFO,
                {
                  applicationId: baseInformation?.applicationId || '',
                },
              )}
              className={commonStyles.applicationLink}
              target="_blank"
            >
              Go to application
            </NavLink>
          )}
        </div>
      </div>
      {baseInformation?.status === CustomerStatus.CLOSED && (
        <div className={commonStyles.closedContent}>
          <div className={commonStyles.closeContentLeft}>
            <div className={commonStyles.closeContentLeftTitle}>
              <IconCloseCircle width={24} height={24} />
              Organization is closed
            </div>
            <div className={commonStyles.closeContentLeftDescription}>
              {baseInformation?.statusChangeReason}
            </div>
          </div>
          {activePermissions?.includes(
            PermissionEnum.INDIVIDUAL_CUSTOMERS_OPEN_ACTION,
          ) && (
            <div className={commonStyles.closeContentRight}>
              <button
                type="button"
                className={commonStyles.reopenButton}
                onClick={() => setReopenPopupVisible(true)}
              >
                Reopen
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default OverviewTopContent;
